import React, { useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import useApiManager from '../../utils/Api/apiManager';
import ConfirmationDialog from '../ConfirmationDialog/ConfirmationDialog';

const ActionsButton = ({ itemIds, setSelectedRows, setTriggerFetch }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const { del } = useApiManager();

  const handleOpenDialog = () => {
    setOpenDialog(true);
};

const handleCloseDialog = () => {
    setOpenDialog(false);
};


  // Open the Menu
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Close the Menu
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Handle Delete action
  const handleDelete = async () => {
    if (itemIds.length == 0) {
      alert("There is no task selected.")
      return;
    }
    setLoading(true);
    try {
      // Make the API call to delete the selected items
      await del('/tasks', { data: { ids: itemIds } });
      // Handle success (e.g., show a notification)
    } catch (error) {
      console.error('Error deleting items:', error);
      // Handle error (e.g., show a notification)
    } finally {
      setLoading(false);
      handleClose(); // Close the menu after action
      handleCloseDialog();
      setTriggerFetch(true);
      setSelectedRows([]); 
      // to refresh the datagrid
    }
  };

  return (
    <div>
      <Button variant="outlined" onClick={handleClick}>Actions</Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleOpenDialog} disabled={loading}>
          {loading ? 'Deleting...' : 'Delete'}
        </MenuItem>
      </Menu>
      <ConfirmationDialog
        open={openDialog}
        title="Confirm Action"
        content="Are you sure you want to delete this Task? This action cannot be undone!"
        onClose={handleCloseDialog}
        onConfirm={handleDelete}
        confirmText="Confirm"
        cancelText="Cancel"
      />
    </div>
  );
};

export default ActionsButton;
